import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { DashText } from 'legacy/dash-blocks/dash-text/DashText'
import { dashPixels } from 'legacy/dash-blocks/foundation/spacing-units/spacingUnits.types'

export interface FormFieldErrorProps {
  error: string | undefined
}

const errorContainerStyles = css({
  minHeight: dashPixels.PX24,
  paddingTop: dashPixels.PX8,
})

export const FormFieldError: FunctionComponent<FormFieldErrorProps> = ({ error }) => (
  <div css={errorContainerStyles}>
    {error && (
      <DashText size="small" color="danger">
        {error}
      </DashText>
    )}
  </div>
)
